import { OpenInNew } from '@mui/icons-material';
import React from 'react';
import { Link } from 'react-router-dom';

import XDButton from './buttons/XDButton';

interface Props {
  children: string | React.ReactNode;
  to: string;
}

export default function TableHyperlinkButton(props: Props) {
  return (
    <Link to={props.to} target={'_blank'} className={'-mx-3 -my-1 text-slate-800 hover:text-inherit'}>
      <XDButton className={'w-full text-left'}>
        {typeof props.children === 'string' ? (
          <span className={'normal-case font-normal'}>
            {props.children} <OpenInNew className={'-mt-0.5'} />
          </span>
        ) : (
          props.children
        )}
      </XDButton>
    </Link>
  );
}
